<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 justify-content-sm-center">
                    <div
                        class="col-12 mt-5 mb-4 d-flex justify-content-md-center align-items-center"
                    >
                        <h2 class="color--purple-2 heading-spacing--large">
                            Inloggen
                        </h2>
                    </div>

                    <div
                        class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                    >
                        <p>{{ statusMessage }}</p>
                    </div>

                    <form action="">
                        <div class="row justify-content-md-center">
                            <div class="col-12 col-sm-10 col-md-6 mb-4">
                                <label
                                    for="username"
                                    class="col-12 label--default"
                                    >Gebruikersnaam (e-mail)</label
                                >
                                <input
                                    id="username"
                                    v-model="username"
                                    class="input--default input--rounded"
                                    type="text"
                                    placeholder="gebruiker@verwonderomdehoek.nl"
                                />
                            </div>
                        </div>

                        <div class="row justify-content-md-center">
                            <div class="col-12 col-sm-10 col-md-6 mb-4">
                                <label
                                    for="password"
                                    class="col-12 label--default"
                                    >Wachtwoord</label
                                >
                                <input
                                    id="password"
                                    v-model="password"
                                    class="input--default input--rounded"
                                    placeholder="Vul jouw wachtwoord in"
                                    rules="required"
                                    type="password"
                                />
                            </div>
                        </div>
                        <div
                            v-if="!processing"
                            class="col-12 d-flex justify-content-sm-center"
                        >
                            <button
                                class="btn btn--blue-7 col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                                @click="login"
                            >
                                <span>
                                    Inloggen
                                    <i class="fas fa-arrow-right ml-2"></i>
                                </span>
                            </button>
                        </div>
                        <div
                            v-else
                            class="col-12 justify-content-sm-center text-center"
                        >
                            <span>Een moment geduld...</span>
                        </div>
                        <div class="col-12 mt-2">
                            <ul
                                class="row list-unstyled justify-content-sm-center
                            "
                            >
                                <li
                                    class="col-12 col-sm-6 col-md-3 col-lg-2 text-center"
                                >
                                    <a :href="passwordForgotUrl"
                                        >Wachtwoord vergeten?</a
                                    >
                                </li>
                                <li
                                    class="col-12 col-sm-6 col-md-3 col-lg-2 text-center"
                                >
                                    <a :href="registerUrl">Nog geen account?</a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="!processing" class="col-12">
                            <p class="text-center">{{ errorMessage }}</p>
                        </div>

                        <div
                            class="mt-3 pt-4 border-top-2 d-flex justify-content-md-center align-items-center"
                        >
                            <a :href="umbracoUrl" target="_blank"
                                >Klik hier om als aanbieder in te loggen</a
                            >
                        </div>
                        <div
                            class="d-flex justify-content-md-center align-items-center"
                        >
                            <a
                                href="mailto:info@verwonderomdehoek.nl"
                                target="_blank"
                                >Hulp nodig bij jouw account?</a
                            >
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';

axios.get('/api/recaptcha/get').then(response => {
    Vue.use(VueReCaptcha, { siteKey: response });
});

export default {
    data() {
        return {
            username: '',
            password: '',
            user: {},
            passwordForgotUrl: '',
            registerUrl: '',
            umbracoUrl: '',
            errorMessage: '',
            statusMessage: '',
            processing: false
        };
    },
    created() {
        this.passwordForgotUrl = this.getPasswordForgotUrl();
        this.registerUrl = this.getRegisterUrl();
        this.umbracoUrl = window.location.origin + '/umbraco';
        const reset = this.$route.query.resetsuccess;

        if (reset == 'true') {
            this.statusMessage =
                'Wachtwoord succesvol aangepast. Je kan direct met de nieuwe gegevens inloggen.';
        }
    },
    methods: {
        login(e) {
            e.preventDefault();
            this.errorMessage = '';
            this.statusMessage = '';
            this.processing = true;
            axios
                .post('/clientdashboard/account/login', {
                    username: this.username,
                    password: this.password
                })
                .then(response => {
                    if (response.data.success) {
                        if (
                            this.$route.query.activityId &&
                            this.$route.query.providerId
                        ) {
                            axios
                                .get('/api/registration/registrationformurl')
                                .then(response => {
                                    window.location.replace(
                                        response.data +
                                            '?activityId=' +
                                            this.$route.query.activityId +
                                            '&providerId=' +
                                            this.$route.query.providerId
                                    );
                                })
                                .catch(() => {
                                    this.processing = false;
                                });
                        } else {
                            window.location.replace(response.data.redirectUrl);
                        }
                    } else {
                        this.errorMessage = response.data.errorMsg;
                        this.processing = false;
                    }
                    return;
                })
                .catch(error => {
                    this.errorMessage = error.response.data.ExceptionMessage;
                    this.processing = false;
                })
                .finally(() => {});
        },
        logout() {
            axios
                .post('/clientdashboard/account/logout', {})
                .then(response => {
                    if (response.data.success) {
                        window.location.replace(response.data.redirectUrl);
                    } else {
                        this.errorMessage = response.data.errorMsg;
                    }
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                });
        },
        getPasswordForgotUrl() {
            axios
                .get('/clientdashboard/navigation/getpasswordforgoturl')
                .then(response => {
                    this.passwordForgotUrl = response.data;
                })
                .catch(() => false);
        },
        getRegisterUrl() {
            axios
                .get('/clientdashboard/navigation/getregisterurl')
                .then(response => {
                    this.registerUrl = response.data;
                })
                .catch(() => false);
        }
    }
};
</script>
<style></style>
